import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Logout = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h7V3H3v18h9v-2H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 12-4-4v3H9v2h8v3z"
  }));
});
Logout.displayName = 'Logout';
export var LogoutDimensions = {
  height: 24,
  width: 24
};